const crudConfig = {
    defaultModel: {
      active: true
    },
    organisations: {
      table: {
        tableColumns: [
          {
            prop: 'name',
            label: 'Name',
            minWidth: 160
          },
          {
            prop: 'description',
            label: 'Description',
            minWidth: 200
          },
          {
            prop: 'organisationType',
            label: 'Type',
            minWidth: 100
          }
        ]
      },
      form: {
        newTitle: 'New organisation',
        editTitle: 'Edit organisation',
        formFields: [
          {
            prop: 'name',
            label: 'Name',
            required: true
          },
          {
            prop: 'description',
            label: 'Description',
            minWidth: 200
          },
          {
            prop: 'organisationType',
            label: 'Type',
            type: 'select',
            listData: [
              {value: 'OEM', label: 'OEM'},
              {value: 'RESELLER', label: 'Reseller'},
              {value: 'CUSTOMER', label: 'Customer'},
            ]
          },
          {
            prop: 'active',
            label: 'Active',
            type: 'boolean'
          }
        ]
      }
    },
    assets: {
        table: {
          tableColumns: [
            {
              prop: 'name',
              label: 'Name',
              minWidth: 160,
              sortable: true
            },
            {
              prop: 'registrationNumber',
              label: 'Registration number',
              minWidth: 160,
              sortable: true
            },
            {
              prop: 'brand',
              label: 'Brand',
              minWidth: 70,
              sortable: true
            },
            {
              prop: 'model',
              label: 'Model',
              minWidth: 100,
              sortable: true
            },
            {
              prop: 'assetType',
              label: 'Type',
              minWidth: 100,
              sortable: true
            },
            {
              prop: 'energyType',
              label: 'Energy',
              minWidth: 100,
              sortable: true
            }
          ],
        },
        form: {
            newTitle: 'New asset',
            editTitle: 'Edit asset',
            formFields: [
              {
                prop: 'name',
                label: 'Name',
                required: true
              },
              {
                prop: 'registrationNumber',
                label: 'Registration Number',
                required: false
              },
              {
                prop: 'brand',
                label: 'Brand'
              },
              {
                prop: 'model',
                label: 'Model'
              },
              {
                prop: 'odometer',
                label: 'Odometer',
                type: 'integer'
              },
              {
                prop: 'assetType',
                label: 'Type',
                type: 'select',
                listData: [
                  {value: 'CAR', label: 'Car'},
                  {value: 'VAN', label: 'Van'},
                  {value: 'TRUCK', label: 'Truck'},
                  {value: 'COACH', label: 'Coach'},
                  {value: 'MACHINE', label: 'Machine'},
                  {value: 'UNKNOWN', label: 'Unknown'}
                ]
              },
              {
                prop: 'energyType',
                label: 'Energy Type',
                type: 'select',
                listData: [
                  {value: 'GASOLINE', label: 'Gasoline'},
                  {value: 'DIESEL', label: 'Diesel'},
                  {value: 'ELECTRIC', label: 'Electric'},
                  {value: 'HYBRID', label: 'Hybrid'},
                  {value: 'HYDROGEN', label: 'Hydrogen'},
                  {value: 'LPG', label: 'LPG'},
                  {value: 'CNG', label: 'CNG'},
                  {value: 'UNKNOWN', label: 'Unknown'}
                ]
              },
              {
                prop: 'fixedDriver',
                label: 'Fixed driver',
                type: 'boolean'
              },
              {
                prop: 'active',
                label: 'Active',
                type: 'boolean'
              },
              {
                prop: 'externalId',
                label: 'External ID',
              }
            ],
        },
    },
    devices: {
      table: {
        tableColumns: [
            {
              prop: 'name',
              label: 'Name',
              minWidth: 160,
              sortable: true
            },
            {
              prop: 'identifier',
              label: 'Device identifier',
              minWidth: 160,
              sortable: true
            },
            {
              prop: 'deviceType',
              label: 'Device type',
              minWidth: 100,
              sortable: true
            }
          ]
      },
      form: {
        newTitle: 'New device',
        editTitle: 'Edit device',
        formFields: [
          {
            prop: 'name',
            label: 'Name',
            required: true
          },
          {
            prop: 'identifier',
            label: 'Device identifier',
            required: true
          },
          {
            prop: 'deviceType',
            label: 'Type',
            type: 'select',
            listData: [
              {value: 'MD_C4', label: 'MD C4'},
              {value: 'ANDROID', label: 'Android'},
              {value: 'QAN_ALL', label: 'Qan All'},
            ]
          },
          {
            prop: 'active',
            label: 'Active',
            type: 'boolean'
          },
          {
            prop: 'externalId',
            label: 'External ID',
          }
        ]
      }
    },
    drivers: {
      model: {
        firstName: '',
        lastName: '',
        code: '',
        tachoCode: '',
        keyCodes: [],
        email: '',
        phone: '',
        active: true
      },
      table: {
        tableColumns: [
          {
            prop: 'firstName',
            label: 'First name',
            minWidth: 120,
            sortable: true
          },
          {
            prop: 'lastName',
            label: 'Last name',
            minWidth: 120,
            sortable: true
          },
          {
            prop: 'code',
            label: 'Code',
            minWidth: 100,
            sortable: true
          },
          {
            prop: 'tachoCode',
            label: 'Tacho code',
            minWidth: 100,
            sortable: true
          },
          {
            prop: 'keyCodes',
            label: 'Key codes',
            minWidth: 110,
            sortable: true
          },
          {
            prop: 'email',
            label: 'E-mail',
            minWidth: 120,
            sortable: true
          },
          {
            prop: 'phone',
            label: 'Phone',
            minWidth: 100,
            sortable: true
          }
        ]
      },
      form: {
        newTitle: 'New driver',
        editTitle: 'Edit driver',
        formFields: [
          {
            prop: 'firstName',
            label: 'First name',
            required: true
          },
          {
            prop: 'lastName',
            label: 'Last name',
            required: true
          },
          {
            prop: 'code',
            label: 'Login code'
          },
          {
            prop: 'tachoCode',
            label: 'Tacho code'
          },
          {
            prop: 'keyCodes',
            label: 'Key code',
            array: true
          },
          {
            prop: 'email',
            label: 'E-mail'
          },
          {
            prop: 'phone',
            label: 'Phone'
          },
          {
            prop: 'active',
            label: 'Active',
            type: 'boolean'
          },
          {
            prop: 'externalId',
            label: 'External ID',
          }
        ]
      }
    },
    groups: {
        table: {
          tableColumns: [
          {
            prop: 'name',
            label: 'Name',
            minWidth: 160,
            sortable: true
          },
          {
            prop: 'description',
            label: 'Description',
            minWidth: 200
          },
          {
            prop: 'fuelUsage',
            label: 'Ref. Fuel',
            minWidth: 100
          }
        ]
      },
      form: {
        newTitle: 'New group',
        editTitle: 'Edit group',
        formFields: [
          {
            prop: 'name',
            label: 'Name',
            required: true
          },
          {
            prop: 'description',
            label: 'Description'
          },
          {
            prop: 'fuelUsage',
            label: 'Reference fuel usage'
          },
          {
            prop: 'active',
            label: 'Active',
            type: 'boolean'
          },
          {
            prop: 'externalId',
            label: 'External ID',
          }
        ]
      }
    },
    configurationgroups: {
      table: {
        tableColumns: [
          {
            prop: 'name',
            label: 'Name',
            minWidth: 160,
            sortable: true
          },
          {
            prop: 'description',
            label: 'Description'
          },
          {
            prop: 'assetType',
            label: 'Type',
            minWidth: 100,
            sortable: true
          },
          {
            prop: 'energyType',
            label: 'Energy',
            minWidth: 100,
            sortable: true
          }
        ]
      },
      form: {
        newTitle: 'New configuration group',
        editTitle: 'Edit configuration group',
        formFields: [
          {
            prop: 'name',
            label: 'Name',
            required: true
          },
          {
            prop: 'description',
            label: 'Description'
          },
          {
            prop: 'assetType',
            label: 'Type',
            type: 'select',
            listData: [
              {value: 'CAR', label: 'Car'},
              {value: 'VAN', label: 'Van'},
              {value: 'TRUCK', label: 'Truck'},
              {value: 'COACH', label: 'Coach'},
              {value: 'MACHINE', label: 'Machine'},
              {value: 'UNKNOWN', label: 'Unknown'}
            ]
          },
          {
            prop: 'energyType',
            label: 'Energy Type',
            type: 'select',
            listData: [
              {value: 'BENZINE', label: 'Benzine'},
              {value: 'DIESEL', label: 'Diesel'},
              {value: 'ELECTRIC', label: 'Electric'},
              {value: 'HYBRID', label: 'Hybrid'},
              {value: 'UNKNOWN', label: 'Unknown'}
            ]
          },
          {
            prop: 'active',
            label: 'Active',
            type: 'boolean'
          },
          {
            prop: 'externalId',
            label: 'External ID',
          }
        ]
      }
    },
    users: {
      table: {
        tableColumns: [
          {
            prop: 'name',
            label: 'Name',
            minWidth: 160,
            sortable: true
          },
          {
            prop: 'email',
            label: 'E-mail',
            minWidth: 120,
            sortable: true
          },
          {
            prop: 'phone',
            label: 'Phone',
            minWidth: 100,
            sortable: true
          },
          {
            prop: 'userRole',
            label: 'Role',
            minWidth: 110,
            sortable: true
          },
          {
            prop: 'timezone',
            label: 'Time zone',
            minWidth: 120,
            sortable: true
          }
        ]
      },
      form: {
        newTitle: 'New user',
        editTitle: 'Edit user',
        formFields: [
          {
            prop: 'name',
            label: 'Name',
            required: true
          },
          {
            prop: 'password',
            label: 'Password',
            format: 'password',
            required: true
          },
          {
            prop: 'email',
            label: 'E-mail',
            required: true
          },
          {
            prop: 'phone',
            label: 'Phone'
          },
          {
            prop: 'userRole',
            label: 'User role',
            type: 'select',
            listData: [
              {value: 'OEM', label: 'OEM'},
              {value: 'RESELLER', label: 'Reseller'},
              {value: 'CUSTOMERADMIN', label: 'Customer admin'},
              {value: 'INTEGRATOR', label: 'Integrator'},
              {value: 'USER', label: 'User'},
              {value: 'DRIVER', label: 'Driver'},
            ]
          },
          {
            prop: 'timezone',
            label: 'Time zone'
          },
          {
            prop: 'active',
            label: 'Active',
            type: 'boolean'
          }
        ]
      }
    },
};

export default crudConfig

/*
	- _apiPrefix (string): global prefix for all API URLs
	_ _apiHandler (object): global handler for all API calls

	- api (object):
		- handler (object): handler for API calls.
			If not present, the default REST implementation is used.
		- prefix (string): prefix to be used for all URLs
		- getAll (string): URL for API table request
		- put (string): URL for updating a record
		- post (string): URL for adding a record
		- delete (string): URL for deleting a record

	- title (string): entity title.
		If not present, the capitalized route is used.

	- fields (array): fields to be used in table and form when not present in their
		respective sections.
	- labels (array): labels to be used in table and form when not present in their
		respective sections. Labels are optional, and if not found, fields are
		capitalized and used as labels.

	- table:
		- fields (array): fields to be used in table
		- labels (array): labels to be used in table
		- buttons (array): buttons to be used in table
		- hdrClasses (array): classes to apply to header cells
		- cellClasses (array): classes to apply to data cells
	- form:
		- fields (array): fields to be used in form
		- labels (array): labels to be used in form
		- newTitle (string): title to be used by the "New ..." form. If not present, the general title is used.
		- editTitle (string): title to be used by the "Edit ..." form. If not present, the general title is used.

	- Field meta:
		- type: string, date, time, email, select, or custom-registered type handler.
			Types are a way to reuse common meta rules: if a rule is not found in
			the "meta" structure, it is searched in the type.
		- listData: array of value/label pairs used by the 'select' type
		- cellRender: custom cell rendering function. Returns plain text.
		- cellRenderHTML: custom cell rendering function that returns HTML.
			=> Rendering user-provided content in HTML should be avoided,
				see https://vuejs.org/v2/guide/syntax.html#Raw-HTML.
				Whenever possible, use the cellRenderNode alternative instead.
		- cellRenderNode: custom cell rendering function that returns a
			virtual DOM node.
		- inputRender: custom input rendering function. When rendering input data
			in forms, this function is used when present, otherwise cellRender is
			used.
		- parse: custom form input parsing function, used when reading input from user.
		- cellClass: custom function to compute cell class from cell value
		- component: Vue component used to render the input in a form
		- focus: focus on form input (defaults to first input in form)
		- attrs: attributes to be applied to the form input for this field
*/
